export default __webpack_public_path__ + "static/media/kakao.66dab308.png";